import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, PrinterIcon, SparklesIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <DownloadIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B8A]" data-id="element-13" />,
    title: 'Descarga inmediata',
    description: 'Comprás hoy y lo recibís al instante.',
    bgColor: 'bg-[#FF6B8A]/10'
  }, {
    icon: <PrinterIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#9B8FE8]" data-id="element-14" />,
    title: 'Imprimí sin límites',
    description: 'Podés usar tus páginas favoritas todas las veces que quieras.',
    bgColor: 'bg-[#9B8FE8]/10'
  }, {
    icon: <SparklesIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FFD166]" data-id="element-15" />,
    title: 'Muchísimas opciones',
    description: 'Distintas colecciones para que siempre haya algo nuevo para colorear.',
    bgColor: 'bg-[#FFD166]/20'
  }];
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 md:gap-8" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#FFFAF7] rounded-2xl p-6 sm:p-8 shadow-sm text-center border border-gray-50" data-id="element-19">
              <div className={`w-12 h-12 sm:w-16 sm:h-16 mx-auto rounded-full flex items-center justify-center mb-4 sm:mb-6 ${benefit.bgColor}`} data-id="element-20">
                {benefit.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#2D2D3F] mb-2 sm:mb-3" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-[#6B7280] text-sm sm:text-base" data-id="element-22">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}